import i18next from '../../config/i18next';

i18next.addResources('es', 'ForgotPassword', {
  Email: 'Email',
  Save: 'Guardar',
  onSuccessTitle: 'El correo fue enviado exitosamente',
  onSuccessMessage:
    'Revisá tu casilla de email para continuar con el cambio de contraseña',
  accept: 'Aceptar',
  back: 'Volver',
  title: 'Restablecer contraseña',
  description:
    'Escribe tu email y te enviaremos las instrucciones para restablecer tu contraseña.',
});

export default i18next;
